export enum CATEGORY {
        CABINETS = "cabinets",
        INTERNAL_LAYINGS = "internalLayings",
        LINEARS = "linears",
        APPLIANCES = "appliances",
        SANITARIES = "sanitaries",
        GENERAL = "general"
}

export enum DECOS {
    FLOOR_TILE = "floorTileBDI",
    HARDWOOD = "hardwoodBDI",
    PAINT = "paintBDI",
    WALL_TILE = "wallTileBDI"
}

export class BomDataHelper {

    
    static orderedCatList:string[] = [CATEGORY.GENERAL, CATEGORY.CABINETS, CATEGORY.INTERNAL_LAYINGS, CATEGORY.LINEARS, CATEGORY.APPLIANCES, CATEGORY.SANITARIES];

    static _eanRgx:RegExp = /^([\d]{13})/gi;

    static _reduceChildren(target:any[], item:any, blockIndex:number){
        item.blockIndex = blockIndex;
        if(item.children){
            if(item.price){
                let _c = Object.assign({}, item);
                delete _c.children
                target.push(_c);
            }
            for (let i = 0; i < item.children.length; i++){
                this._reduceChildren(target, item.children[i], blockIndex);
            }
        } else {
            if(item.price){
                target.push(item);
            } else if(!item.price && this._eanRgx.test(item.reference)){
                let _c = Object.assign({}, item);
                _c.price = { current : { value : 0 }};
                target.push(_c);
            }
            
        }
    }

    static extractBlockGroupedProductsList(data: any) {
        let _pList = this.extractFlatProductsList(data, false);

        let _originalBomItems = data.products && data.products.concat(data.linears, data.packs);

        let _r = {
            unavailablePrice:true,
            empty:(_pList.products.length === 0),
            blocks:[],
            totalByCategories:this.orderedCatList.map(cat=>{
                return {key:cat,deee:0,ecomob:0,price:0}
            }),
            totalDeee: 0,
            totalEcomob: 0,
            totalPrice: 0
        }
        if(_pList.unavailablePrice){
            return _r;
        }

        _r.unavailablePrice = false;
        _pList.products.forEach((p)=>{

            let _cat:string = CATEGORY.GENERAL;

            let _block;

            _block = _r.blocks.find(b=>b.blockIndex === p.blockIndex);

            if(!_block) {

                let _bomBlock = _originalBomItems[p.blockIndex];
                
                _block = {
                    thumbnailURLSmall : (_bomBlock.thumbnailURLSmall != "") ? _bomBlock.thumbnailURLSmall : p.thumbnailURLSmall,
                    blockIndex : p.blockIndex,
                    title : _bomBlock.name,
                    subtitle : _bomBlock.shortDescription,
                    nomenclatureNumber : _bomBlock.nomenclatureNumber ? _bomBlock.nomenclatureNumber : 0,
                    order : _bomBlock.nomenclatureNumber ? _bomBlock.nomenclatureNumber : (_pList.products.length + p.blockIndex),
                    rows:[],
                    deee: 0,
                    ecomob: 0,
                    price: 0
                }
               
                _r.blocks.push(_block);
            }
            let _alreadyPopulatedRow = _block.rows.find((row)=>row.reference === p.reference);
            if(_alreadyPopulatedRow){
                _alreadyPopulatedRow.quantity += p.quantity || 1;
                _alreadyPopulatedRow.totalPrice += p.totalPrice;
                _alreadyPopulatedRow.totalDeee += p.totalDeee;
                _alreadyPopulatedRow.totalEcomob += p.totalEcomob;
            } else {
                let _clone = Object.assign({}, p);
                _clone.quantity = p.quantity || 1;
                _block.rows.push(_clone);
            }

            let _totalCat = _r.totalByCategories.find(cat=>cat.key == _cat);

            _totalCat.price += p.totalPrice;
            _totalCat.deee += p.totalDeee;
            _totalCat.ecomob += p.totalEcomob;

            _block.price += p.totalPrice;
            _block.deee += p.totalDeee;
            _block.ecomob += p.totalEcomob;

            _r.totalPrice += p.totalPrice;
            _r.totalDeee += p.totalDeee;
            _r.totalEcomob += p.totalEcomob;
            
        });

        _r.blocks = _r.blocks.sort((a,b)=>{
            return a.order - b.order;
        });

        _r.totalByCategories = _r.totalByCategories.filter((cat)=>{
            return cat.price > 0;
        });

         //add decos
         let decosBlock = this.extractBlockGroupDecos(data);
         if (decosBlock.length > 0) {
            _r.blocks = _r.blocks.concat(decosBlock);
            decosBlock.forEach(b => {
                _r.totalPrice += b.price;
                _r.totalDeee += b.deee;
                _r.totalEcomob += b.ecomob;
                if (_r.totalByCategories.length > 0) {
                    _r.totalByCategories[0].deee += b.deee;
                    _r.totalByCategories[0].ecomob += b.ecomob;            
                    _r.totalByCategories[0].price += b.price;    
                } else {
                    _r.totalByCategories = [];
                    _r.totalByCategories.push({
                        key: CATEGORY.GENERAL,
                        deee: b.deee,
                        ecomob: b.ecomob,
                        price: b.price
                    });
                }                
            });
            _r.empty = false;
         }
         
        return _r;
    }


    static extractCategoryGroupedProductsList(data: any) {
        let _pList = this.extractFlatProductsList(data);
        let _r = {
            unavailablePrice:true,
            empty:(_pList.products.length === 0),

            totalDeee: 0,
            totalEcomob: 0,
            totalPrice: 0
        };

        this.orderedCatList.map(cat=>{
            _r[cat] = [];
            _r[cat+"TotalPrice"] = 0;
            _r[cat+"TotalDeee"] = 0;
            _r[cat+"TotalEcomob"] = 0;
        });


        if(_pList.unavailablePrice){
            return _r;
        }

        _r.unavailablePrice = false;

        _pList.products.forEach((p)=>{
            let _cat:string = CATEGORY.GENERAL;
            _r[_cat].push(p);
            _r[_cat+"TotalPrice"] += p.totalPrice;
            _r[_cat+"TotalDeee"] += p.totalDeee;
            _r[_cat+"TotalEcomob"] += p.totalEcomob;
            _r.totalPrice += p.totalPrice;
            _r.totalDeee += p.totalDeee;
            _r.totalEcomob += p.totalEcomob;
        });

        return _r;
    }

    static extractFlatProductsList(data: any, factorize:boolean=true) {

        // console.log(data);
        let _r = {
            unavailablePrice:false,
            products:[]
        };

        let _productList = [];
        let _factorisedProductList = [];

        // 1/ regroup all products into one array
        var allItems = data.products && data.products.concat(data.linears, data.packs);

        if(!allItems) return _r;

        // 2/ products levels flattening
        allItems
          .filter(i => i !== undefined)
          .forEach((item, index) => {
            this._reduceChildren(_productList, item, index);
          });

        if(_productList.find((product)=>(product.isPriceless || product.isExpired))){
            _r.unavailablePrice =true;
        }

        

        // 3/ cleaning
        _productList = _productList.filter((product)=>(!product.isPriceless && !product.isExpired));

        // 4/ factoring
        _productList.map((product)=>{
            let _alreadyPopulated = _factorisedProductList.find((factorisedProduct)=>factorisedProduct.reference === product.reference);
            if(factorize && _alreadyPopulated){
                _alreadyPopulated.quantity += product.quantity || 1;
            } else {
                let _clone = Object.assign({}, product);
                _clone.quantity = product.quantity || 1;
                _factorisedProductList.push(_clone);
            }
        });
        
        // 5/ taxes
        _factorisedProductList.map((row)=>{
            row.ecomob = 0;
            row.deee = 0;
            if(row.price.current.additionalData){
                if(row.price.current.additionalData.ecomob) row.ecomob = parseFloat(row.price.current.additionalData.ecomob);
                if(row.price.current.additionalData.deee) row.deee = parseFloat(row.price.current.additionalData.deee);
            }
        });

        // 6/ pricing
        _factorisedProductList.map((row)=>{
            row.totalPrice = row.price.current.value * row.quantity;
            row.totalDeee = row.deee * row.quantity;
            row.totalEcomob = row.ecomob * row.quantity;
        });

        _r.products = _factorisedProductList;
        return _r;

    }

    static extractFlatProductsListWithDecos(data: any) {
        let list = this.extractFlatProductsList(data);
        let decos = this.extractDecos(data);
        if (decos.length > 0) {
            list.products = list.products.concat(decos);
        }
        
        return list;
    }

    static extractBlockGroupDecos(data: any) {
        let decos = this.extractDecos(data);
        let blocks = [];
        decos.forEach(d => {
            let rows = [];
            rows.push(d);
            blocks.push({
                thumbnailURLSmall : d.thumbnailURLSmall,
                blockIndex : 0,
                title : d.name,
                subtitle: d.reference,
                nomenclatureNumber : 0,
                order : 0,
                rows: rows,
                deee: d.totalDeee,
                ecomob: d.totalEcomob,                
                price: d.totalPrice
            });
        });
        return blocks;
    }

    static extractDecos(data: any) {
        let decos = data.decos?.filter(deco => deco.freeTags?.some(tag =>  Object.values(DECOS).includes(tag)));
        decos.forEach(d => {
            d.totalPrice = d.quantity * d.price.current.value;
            if(d.price.current.additionalData?.ecomob) {
                d.ecomob = parseFloat(d.price.current.additionalData.ecomob);
                d.totalEcomob = d.ecomob * d.quantity;
            } ;
            if(d.price.current.additionalData?.deee) {
                d.deee = parseFloat(d.price.current.additionalData.deee);
                d.totaDeee = d.deee * d.quantity;
            }
        })
        return decos;
    }
}